import { render } from "./EditPageForm.vue?vue&type=template&id=8b534ed8&scoped=true"
import script from "./EditPageForm.vue?vue&type=script&lang=js"
export * from "./EditPageForm.vue?vue&type=script&lang=js"

import "./EditPageForm.vue?vue&type=style&index=0&id=8b534ed8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b534ed8"]])

export default __exports__